import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import ExtractByTypename from 'graphql-client/ExtractByTypename';

import {ProcessTaskChipPopoverQuery} from './__generated/ProcessTaskChipPopoverQuery';

export type ProcessTaskForPopoverOrInaccessibleGql = ProcessTaskChipPopoverQuery['processTask'];
export type ProcessTaskForPopoverGql = ExtractByTypename<
  ProcessTaskChipPopoverQuery['processTask'],
  'ProcessTaskNode'
>;

export const PROCESS_TASK_CHIP_POPOVER_QUERY = gql`
  query ProcessTaskChipPopoverQuery($taskId: StrictString!) @skipAudit @engComponent(name: WORKFLOWS) {
    processTask(id: $taskId) {
      ... on ProcessTaskNode {
        id
        humanId
        name
        executionType
        clientOrigin
        taskSchema {
          ... on ProcessTaskSchemaNode {
            id
            name
          }
          ...InaccessibleInfoGraphQL
        }
        assignee {
          ... on UserNode {
            id
            avatarUrl
            name
          }
        }
        status {
          ... on ProcessTaskStatusNode {
            id
            displayName
            statusType
          }
        }
        scheduledOnDate
        fields
        process {
          id
          name
          editUrl
          requestV2Submission {
            ... on RequestV2SubmissionNode {
              id
            }
            ...InaccessibleInfoGraphQL
          }
        }
        ...ProcessTaskProcedureInfoGraphQL
        ...ProcessTaskPipelineInfoGraphQL
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('ProcessTaskProcedureInfo').fragment}
  ${getFragmentWrapper('ProcessTaskPipelineInfo').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
